import { Container, Col, Row } from "reactstrap";
import * as WorkflowQL from "queries/workflow";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import WorkflowSchema from "@common/schema/workflow/public";
import * as widgets from "@shared/widgets/register";
import * as Section from "@repoflow/components/section";

// Hoisted: a config literal is a new object every render and the form provider
// rebuilds its widget tree underneath it. See ../workflow/edit.
//
// Name, title, what it is for, and when it last changed. Deliberately not
// `steps`: that is the unbounded field, it is not on the listing fragment at
// all, and a listing is not where you read a declaration.
const LIST_FIELDS = {
  "/Public/Workflow": {
    fields: ["workflowId", "title", "tags", "updatedAt"],
  },
};

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.workflows"}
        query={WorkflowQL.list}
        variables={params}
        schema={WorkflowSchema}
        widgets={widgets}
        target={{ $ref: "/Public/Workflow" }}
        empty={"No workflows yet."}
        config={LIST_FIELDS}
        content={({ item: { workflowId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${workflowId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
